/*
  Top Spinner — handling-fee auto-charge (Basecamp todo 518757011).

  Keeps the hidden "Handling Fee" product in sync with the cart: one fee unit per unit
  of any product carrying the custom.handling_fee metafield ($20 / $35 / $209 tiers).

  Data comes from snippets/ts-handling-fee.liquid, rendered inside both cart surfaces —
  every section re-render (add to cart, qty change, our own sync) ships fresh numbers,
  so this script only ever diffs "required" vs "current" and converges in one update.

  Safety: a repeat-guard stops retry loops if /cart/update.js cannot apply an update
  (e.g. fee variant unavailable) — same payload won't be retried within 20s.
*/
(function () {
  'use strict';

  var syncing = false;
  var lastPayload = '';
  var lastAt = 0;

  function readData() {
    var els = document.querySelectorAll('[data-ts-handling-fee]');
    if (!els.length) return null;
    try {
      return JSON.parse(els[els.length - 1].textContent);
    } catch (e) {
      return null;
    }
  }

  function swapDrawer(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    var drawer = document.getElementById('CartDrawer');
    if (html && drawer) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('CartDrawer');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    }
    var bubbleHtml = sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var bdoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      var fb = bdoc.querySelector('.shopify-section') || bdoc.body;
      bubble.innerHTML = fb.innerHTML;
    }
  }

  function sync() {
    if (syncing) return;
    var d = readData();
    if (!d || !d.required) return;
    var updates = {};
    var dirty = false;
    Object.keys(d.required).forEach(function (vid) {
      var want = d.required[vid] || 0;
      var have = (d.current && d.current[vid]) || 0;
      if (want !== have) {
        updates[vid] = want;
        dirty = true;
      }
    });
    if (!dirty) return;

    var payload = JSON.stringify(updates);
    var now = Date.now();
    if (payload === lastPayload && now - lastAt < 20000) return; // repeat-guard
    lastPayload = payload;
    lastAt = now;

    syncing = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        syncing = false;
        if (document.body.classList.contains('template-cart') || window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }
        swapDrawer(state && state.sections);
      })
      .catch(function () { syncing = false; });
  }

  var debounceTimer = null;
  function queueSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 350);
  }

  document.addEventListener('DOMContentLoaded', queueSync);
  if (document.readyState !== 'loading') queueSync();

  // theme pub/sub (pubsub.js): fires on add-to-cart and quantity changes
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, queueSync);
  }

  // fallback: the drawer re-renders its contents on cart changes
  var drawer = document.getElementById('CartDrawer');
  if (drawer && typeof MutationObserver !== 'undefined') {
    new MutationObserver(queueSync).observe(drawer, { childList: true, subtree: true });
  }

  // robust catch-all: any cart mutation (add/change/update/clear) queues a sync,
  // regardless of which theme component performed it. Waits long enough for the
  // theme to swap the drawer HTML (fresh data snippet) before diffing.
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
    var res = origFetch.apply(this, arguments);
    if (isCartMutation) {
      res.then(function () { setTimeout(queueSync, 700); }).catch(function () {});
    }
    return res;
  };
})();
